/**
 * KrutiKala wishlist — localStorage store + page UI
 * Figma Make: WishlistPage.tsx (Saved Creations)
 */
(function () {
  'use strict';

  if (window.KKWishlist) return;

  var LEGACY_STORAGE_KEY = 'kk_wishlist_v1';
  var PENDING_KEY = 'kk_wishlist_pending';
  var SORT_LABELS = {
    recent: 'Recently Added',
    'price-asc': 'Price: Low to High',
    'price-desc': 'Price: High to Low',
    rating: 'Best Rated',
  };

  function session() {
    return window.KKSession || { loggedIn: false, customerId: null, loginUrl: '/account/login' };
  }

  function isLoggedIn() {
    var fromDom = document.documentElement.getAttribute('data-kk-logged-in');
    if (fromDom === 'false') return false;
    if (fromDom === 'true') return true;
    var s = session();
    return !!(s.loggedIn && s.customerId);
  }

  function storageKey() {
    var s = session();
    if (s.customerId) return LEGACY_STORAGE_KEY + '_' + s.customerId;
    return LEGACY_STORAGE_KEY + '_guest';
  }

  function safeReturnTo(value, fallback) {
    if (!value) return fallback;
    try {
      value = decodeURIComponent(value);
    } catch (e) {}
    if (value.charAt(0) !== '/' || value.indexOf('//') === 0) return fallback;
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(value)) return fallback;
    return value;
  }

  function shopifyLoginUrl() {
    return (window.routes && (window.routes.storefront_login_url || window.routes.account_login_url))
      || '/account/login';
  }

  function loginUrl() {
    var url = (window.KKSession && window.KKSession.loginUrl) || shopifyLoginUrl();
    if (!url || url === '/') {
      return shopifyLoginUrl();
    }
    return url;
  }

  function requireLogin(pendingItem) {
    if (isLoggedIn()) return true;
    if (pendingItem) {
      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify(pendingItem));
      } catch (e) {}
    }
    window.location.href = loginUrl();
    return false;
  }

  function migrateLegacyWishlist() {
    if (!isLoggedIn()) return;
    var key = storageKey();
    try {
      if (localStorage.getItem(key)) return;
      var legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
      if (!legacy) return;
      localStorage.setItem(key, legacy);
      localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (e) {}
  }

  function claimPendingWishlist() {
    if (!isLoggedIn()) return;
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      sessionStorage.removeItem(PENDING_KEY);
      if (!raw) return;
      var item = JSON.parse(raw);
      if (item && item.id != null) upsert(item);
    } catch (e) {}
  }

  function read() {
    if (!isLoggedIn()) return [];
    try {
      var raw = localStorage.getItem(storageKey());
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    if (!isLoggedIn()) return;
    try {
      localStorage.setItem(storageKey(), JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('kk:wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    var sid = String(id);
    return read().some(function (item) {
      return String(item.id) === sid;
    });
  }

  function remove(id) {
    var sid = String(id);
    write(
      read().filter(function (item) {
        return String(item.id) !== sid;
      })
    );
  }

  function upsert(item) {
    if (!item || item.id == null) return;
    var list = read().filter(function (row) {
      return String(row.id) !== String(item.id);
    });
    list.unshift(Object.assign({}, item, { savedAt: item.savedAt || Date.now() }));
    write(list);
  }

  function toggle(item) {
    if (!item || item.id == null) return false;
    if (!requireLogin(item)) return false;
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    upsert(item);
    return true;
  }

  function money(cents, format) {
    var amount = (Number(cents) || 0) / 100;
    var formatted = amount.toLocaleString('en-IN', {
      minimumFractionDigits: amount % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    });
    if (format && format.indexOf('{{amount}}') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/g, formatted);
    }
    if (format && format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString('en-IN'));
    }
    return '₹' + formatted;
  }

  function itemFromButton(btn) {
    if (!btn || !btn.dataset.productId) return null;
    return {
      id: btn.dataset.productId,
      handle: btn.dataset.productHandle || '',
      url: btn.dataset.productUrl || '',
      title: btn.dataset.productTitle || '',
      image: btn.dataset.productImage || '',
      price: Number(btn.dataset.productPrice || 0),
      compareAt: Number(btn.dataset.productCompare || 0),
      meta: btn.dataset.productMeta || '',
      region: btn.dataset.productRegion || '',
      rating: Number(btn.dataset.productRating || 0),
      reviews: Number(btn.dataset.productReviews || 0),
      variantId: btn.dataset.variantId || '',
      available: btn.dataset.available !== 'false',
      inventory: btn.dataset.inventory ? Number(btn.dataset.inventory) : null,
      savedAt: Date.now(),
    };
  }

  function syncButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-kk-wishlist]').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (!id) return;
      var on = has(id);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'Remove from saved creations' : 'Add to saved creations';
      if (btn.dataset.productTitle) {
        label = on
          ? 'Remove ' + btn.dataset.productTitle + ' from saved creations'
          : 'Add ' + btn.dataset.productTitle + ' to saved creations';
      }
      btn.setAttribute('aria-label', label);
    });
  }

  function updateBadge() {
    var count = read().length;
    document.querySelectorAll('[data-kk-wishlist-count]').forEach(function (el) {
      if (count > 0) {
        el.hidden = false;
        el.textContent = String(count);
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.hidden = true;
        el.textContent = '';
        el.setAttribute('aria-hidden', 'true');
      }
    });
    document.querySelectorAll('[data-kk-wishlist-link]').forEach(function (link) {
      var base = link.getAttribute('data-kk-wishlist-label') || 'Wishlist';
      link.setAttribute('aria-label', count > 0 ? base + ', ' + count + ' saved' : base);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kk-wishlist]');
    if (!btn) return;
    if (btn.closest('[data-kk-wishlist-page]')) return;
    event.preventDefault();
    event.stopPropagation();
    var item = itemFromButton(btn);
    if (!item) return;
    if (!requireLogin(item)) return;
    if (has(item.id) || btn.classList.contains('is-active')) {
      if (window.KKNotice && typeof window.KKNotice.show === 'function') {
        window.KKNotice.show('This creation is already in your wishlist.');
      } else {
        window.alert('This creation is already in your wishlist.');
      }
      return;
    }
    toggle(item);
    syncButtons();
    updateBadge();
  }, true);

  document.addEventListener('kk:wishlist:change', function () {
    syncButtons();
    updateBadge();
  });

  function initPage(root) {
    if (!root || root.dataset.kkWishlistReady === 'true') return;
    if (root.querySelector('[data-kk-wl-login]')) return;
    root.dataset.kkWishlistReady = 'true';

    var moneyFormat = root.dataset.moneyFormat || '₹{{amount}}';
    var collectionsUrl = root.dataset.collectionsUrl || '/collections/all';
    var materialsUrl = root.dataset.materialsUrl || '/pages/materials';
    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    var skeleton = root.querySelector('[data-kk-wl-skeleton]');
    var emptyEl = root.querySelector('[data-kk-wl-empty]');
    var filledEl = root.querySelector('[data-kk-wl-filled]');
    var gridEl = root.querySelector('[data-kk-wl-grid]');
    var countEls = root.querySelectorAll('[data-kk-wl-count]');
    var sortBtn = root.querySelector('[data-kk-wl-sort-btn]');
    var sortMenu = root.querySelector('[data-kk-wl-sort-menu]');
    var sortLabel = root.querySelector('[data-kk-wl-sort-label]');
    var snackbar = root.querySelector('[data-kk-wl-snackbar]');
    var viewMode = 'grid';
    var sort = 'recent';
    var undoItem = null;
    var undoTimer = null;

    function setCounts(n) {
      countEls.forEach(function (el) {
        if (n > 0) {
          el.hidden = false;
          el.textContent = n + ' saved ' + (n === 1 ? 'creation' : 'creations');
        } else {
          el.hidden = true;
          el.textContent = '';
        }
      });
    }

    function sortedItems() {
      var items = read().slice();
      items.sort(function (a, b) {
        if (sort === 'price-asc') return (a.price || 0) - (b.price || 0);
        if (sort === 'price-desc') return (b.price || 0) - (a.price || 0);
        if (sort === 'rating') return (b.rating || 0) - (a.rating || 0);
        return (b.savedAt || 0) - (a.savedAt || 0);
      });
      return items;
    }

    function isLowStock(item) {
      return item.available !== false && item.inventory != null && item.inventory > 0 && item.inventory <= 5;
    }

    function isOutOfStock(item) {
      return item.available === false;
    }

    function cartBtnHtml(variantId, extraClass) {
      var id = escapeAttr(variantId || '');
      var inCart = !!(window.KKCart && window.KKCart.hasVariant(variantId));
      var label = inCart ? 'Go to Cart' : 'Add to Cart';
      return (
        '<button type="button" class="kk-wl-card__cart' +
        (extraClass ? ' ' + extraClass : '') +
        (inCart ? ' is-in-cart' : '') +
        '" data-kk-wl-add="' +
        id +
        '" data-kk-add-to-cart="' +
        id +
        '" data-kk-add-text="Add to Cart" data-kk-in-cart="' +
        (inCart ? 'true' : 'false') +
        '">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        '<span data-kk-add-label>' +
        label +
        '</span></button>'
      );
    }

    function cardHtml(item) {
      var out = isOutOfStock(item);
      var low = isLowStock(item);
      var compare = item.compareAt > item.price ? item.compareAt : 0;
      var discount = 0;
      if (compare) {
        discount = Math.round(((compare - item.price) / compare) * 100);
      }
      var badges = '';
      if (low && !out) {
        badges += '<span class="kk-wl-badge kk-wl-badge--amber">Only a few left</span>';
      }
      if (out) {
        badges += '<span class="kk-wl-badge kk-wl-badge--dark">Unavailable</span>';
      }

      var img = item.image
        ? '<img src="' +
          item.image +
          '" alt="' +
          escapeAttr(item.title) +
          '" loading="lazy" width="500" height="660">'
        : '<div class="kk-wl-card__ph" aria-hidden="true"></div>';

      var cta = out
        ? '<a class="kk-wl-card__similar" href="' + collectionsUrl + '">Find Similar</a>'
        : cartBtnHtml(item.variantId, '');
      var listCta = out
        ? '<div class="kk-wl-card__oos-row"><span>Currently unavailable</span><a href="' +
          collectionsUrl +
          '">Find Similar →</a></div>'
        : cartBtnHtml(item.variantId, 'kk-wl-card__cart--inline');

      return (
        '<article class="kk-wl-card" data-kk-wl-card data-id="' +
        escapeAttr(item.id) +
        '">' +
        '<div class="kk-wl-card__media' +
        (out ? ' is-oos' : '') +
        '">' +
        '<a class="kk-wl-card__img" href="' +
        escapeAttr(item.url || '#') +
        '" tabindex="-1" aria-hidden="true">' +
        img +
        '</a>' +
        '<div class="kk-wl-card__badges">' +
        badges +
        '</div>' +
        '<button type="button" class="kk-wl-card__heart is-active" data-kk-wl-remove="' +
        escapeAttr(item.id) +
        '" aria-label="Remove ' +
        escapeAttr(item.title) +
        ' from saved creations">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '</button>' +
        (out
          ? '<div class="kk-wl-card__oos"><p>Currently unavailable</p><a href="' +
            collectionsUrl +
            '">Find Similar</a></div>'
          : '<div class="kk-wl-card__hover">' + cta + '</div>') +
        '</div>' +
        '<div class="kk-wl-card__info">' +
        '<div class="kk-wl-card__info-top">' +
        '<a class="kk-wl-card__title" href="' +
        escapeAttr(item.url || '#') +
        '">' +
        escapeHtml(item.title) +
        '</a>' +
        '<button type="button" class="kk-wl-card__heart kk-wl-card__heart--list is-active" data-kk-wl-remove="' +
        escapeAttr(item.id) +
        '" aria-label="Remove ' +
        escapeAttr(item.title) +
        ' from saved creations">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '</button>' +
        '</div>' +
        '<p class="kk-wl-card__price' +
        (compare ? ' kk-wl-card__price--sale' : '') +
        '">' +
        '<span class="kk-wl-card__price-now">' +
        money(item.price, moneyFormat) +
        '</span>' +
        (compare
          ? '<span class="kk-wl-card__price-meta"><s class="kk-wl-card__price-was">' +
            money(compare, moneyFormat) +
            '</s>' +
            (discount ? '<span class="kk-wl-card__off">' + discount + '% OFF</span>' : '') +
            '</span>'
          : '') +
        '</p>' +
        '<div class="kk-wl-card__mobile-cta">' +
        (out
          ? '<a class="kk-wl-card__similar" href="' + collectionsUrl + '">Find Similar →</a>'
          : cartBtnHtml(item.variantId, 'kk-wl-card__cart--outline')) +
        '</div>' +
        '<div class="kk-wl-card__list-cta">' +
        listCta +
        '</div>' +
        '</div>' +
        '</article>'
      );
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function escapeAttr(str) {
      return escapeHtml(str).replace(/'/g, '&#39;');
    }

    function showSnackbar(item) {
      undoItem = item;
      if (!snackbar) return;
      snackbar.hidden = false;
      if (undoTimer) clearTimeout(undoTimer);
      undoTimer = setTimeout(function () {
        hideSnackbar();
      }, 4000);
    }

    function hideSnackbar() {
      undoItem = null;
      if (snackbar) snackbar.hidden = true;
      if (undoTimer) clearTimeout(undoTimer);
    }

    function render() {
      var items = sortedItems();
      var count = items.length;

      if (skeleton) skeleton.hidden = true;

      if (count === 0) {
        if (filledEl) filledEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        setCounts(0);
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (filledEl) filledEl.hidden = false;
      setCounts(count);

      if (gridEl) {
        gridEl.className =
          viewMode === 'list' ? 'kk-wl-grid kk-wl-grid--list' : 'kk-wl-grid kk-wl-grid--grid';
        gridEl.innerHTML = items.map(cardHtml).join('');
        if (window.KKCart && typeof window.KKCart.syncButtons === 'function') window.KKCart.syncButtons();
      }

      if (sortLabel) {
        sortLabel.textContent = SORT_LABELS[sort] || SORT_LABELS.recent;
      }
    }

    function refreshLiveAvailability(items) {
      var jobs = items
        .filter(function (item) {
          return item.handle;
        })
        .slice(0, 24)
        .map(function (item) {
          var productPath = '/products/' + encodeURIComponent(item.handle);
          var rating = fetch(productPath + '?sections=kk-rating-data')
            .then(function (res) {
              if (!res.ok) throw new Error('missing');
              return res.json();
            })
            .then(function (sections) {
              var html = sections && sections['kk-rating-data'];
              if (!html) return;
              var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kk-rating]');
              if (!el) return;
              item.rating = Number(el.getAttribute('data-kk-rating')) || 0;
              item.reviews = Number(el.getAttribute('data-kk-reviews')) || 0;
            })
            .catch(function () {});

          var details = fetch(productPath + '.js')
            .then(function (res) {
              if (!res.ok) throw new Error('missing');
              return res.json();
            })
            .then(function (product) {
              var variant =
                product.variants.find(function (v) {
                  return String(v.id) === String(item.variantId);
                }) || product.variants[0];
              item.title = product.title || item.title;
              item.url = '/products/' + product.handle;
              item.handle = product.handle;
              if (product.featured_image) item.image = product.featured_image;
              if (variant) {
                item.price = variant.price;
                item.compareAt = variant.compare_at_price || 0;
                item.variantId = String(variant.id);
                item.available = !!variant.available;
                if (typeof variant.inventory_quantity === 'number') {
                  item.inventory = variant.inventory_quantity;
                }
              }
            })
            .catch(function () {});

          return Promise.all([rating, details]);
        });

      return Promise.all(jobs).then(function () {
        write(items);
      });
    }

    root.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-kk-wl-remove]');
      if (removeBtn) {
        event.preventDefault();
        var id = removeBtn.getAttribute('data-kk-wl-remove');
        var item = read().find(function (row) {
          return String(row.id) === String(id);
        });
        var card = removeBtn.closest('[data-kk-wl-card]');
        if (card) card.classList.add('is-removing');
        setTimeout(function () {
          if (item) showSnackbar(item);
          remove(id);
          render();
          updateBadge();
          syncButtons();
        }, 280);
        return;
      }

      var addBtn = event.target.closest('[data-kk-wl-add]');
      if (addBtn) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var variantId = addBtn.getAttribute('data-kk-wl-add');
        if (!variantId) {
          window.location.href = collectionsUrl;
          return;
        }
        if (addBtn.getAttribute('data-kk-in-cart') === 'true' || (window.KKCart && window.KKCart.hasVariant(variantId))) {
          if (window.KKCart && window.KKCart.goToCart) window.KKCart.goToCart();
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        addBtn.disabled = true;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var exists = (cart.items || []).some(function (item) {
              return String(item.variant_id) === String(variantId) || String(item.id) === String(variantId);
            });
            if (exists) {
              if (window.KKCart && window.KKCart.mark) window.KKCart.mark(variantId);
              if (window.KKCart && window.KKCart.goToCart) window.KKCart.goToCart();
              else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            return fetch(cartAddUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
            }).then(function (res) {
              return res.text().then(function (text) {
                var body = {};
                try {
                  body = text ? JSON.parse(text) : {};
                } catch (e) {}
                var already = res.status === 422 || body.status || /already in (your )?cart|maximum quantity/i.test(
                  String((body && (body.description || body.message)) || text || '')
                );
                if (already) {
                  if (window.KKCart && window.KKCart.mark) window.KKCart.mark(variantId);
                  return;
                }
                if (!res.ok) throw new Error('cart');
                if (window.KKCart && window.KKCart.mark) window.KKCart.mark(variantId);
                if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kk-wishlist' });
                }
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              });
            });
          })
          .catch(function () {})
          .finally(function () {
            addBtn.disabled = false;
          });
        return;
      }

      var viewBtn = event.target.closest('[data-kk-wl-view]');
      if (viewBtn) {
        viewMode = viewBtn.getAttribute('data-kk-wl-view') || 'grid';
        root.querySelectorAll('[data-kk-wl-view]').forEach(function (btn) {
          var on = btn === viewBtn;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
        return;
      }

      if (event.target.closest('[data-kk-wl-undo]') && undoItem) {
        event.preventDefault();
        upsert(undoItem);
        hideSnackbar();
        render();
        updateBadge();
        syncButtons();
        return;
      }

      if (event.target.closest('[data-kk-wl-dismiss]')) {
        event.preventDefault();
        hideSnackbar();
        return;
      }

      var sortOpt = event.target.closest('[data-kk-wl-sort]');
      if (sortOpt) {
        sort = sortOpt.getAttribute('data-kk-wl-sort') || 'recent';
        if (sortMenu) sortMenu.hidden = true;
        if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
        render();
        return;
      }

      if (sortBtn && sortBtn.contains(event.target)) {
        var open = sortMenu && sortMenu.hidden;
        if (sortMenu) sortMenu.hidden = !open;
        sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });

    document.addEventListener('click', function (event) {
      if (!sortMenu || sortMenu.hidden) return;
      if (sortBtn && sortBtn.contains(event.target)) return;
      if (sortMenu.contains(event.target)) return;
      sortMenu.hidden = true;
      if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('kk:wishlist:change', function () {
      if (root.isConnected) render();
    });

    var current = read();
    setTimeout(function () {
      render();
      if (current.length) {
        refreshLiveAvailability(current).then(render);
      }
    }, 400);
  }

  function boot() {
    migrateLegacyWishlist();
    claimPendingWishlist();
    syncButtons();
    updateBadge();
    document.querySelectorAll('[data-kk-wishlist-page]').forEach(initPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.KKWishlist = {
    read: read,
    write: write,
    has: has,
    remove: remove,
    upsert: upsert,
    toggle: toggle,
    syncButtons: syncButtons,
    updateBadge: updateBadge,
  };
})();
